import { LogIn, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

const GoogleMark = () => (
  <svg viewBox="0 0 48 48" className="w-4 h-4" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.5 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.9 6.1C12.4 13.7 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-2.8-.4-4H24v8.1h12.9c-.3 2.1-1.7 5.3-4.8 7.4l7.4 5.7c4.4-4.1 7-10.1 7-17.2z" />
    <path fill="#FBBC05" d="M10.5 28.6A14.6 14.6 0 0 1 9.7 24c0-1.6.3-3.2.8-4.6l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.9-6.1z" />
    <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.4-5.7c-2 1.4-4.7 2.4-8.5 2.4-6.3 0-11.6-4.2-13.5-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

export const GoogleButton = ({ path, label = "Sign in with Google", className = "", testId = "google-signin-btn" }) => {
  const { login } = useAuth();
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => login(path)}
      className={`inline-flex items-center justify-center gap-2 border border-slate-300 bg-white hover:border-[#0A192F] text-[#0A192F] px-4 py-2.5 text-sm font-medium transition-colors ${className}`}
    >
      <GoogleMark /> {label}
    </button>
  );
};

export const NavAuth = ({ textCls, hoverCls }) => {
  const { user, loading, login, logout } = useAuth();
  if (loading) return null;
  if (!user) {
    return (
      <button
        type="button"
        data-testid="nav-signin"
        onClick={() => login(window.location.pathname)}
        className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest ${textCls} ${hoverCls} transition-colors`}
      >
        <LogIn className="w-3.5 h-3.5" /> Sign in
      </button>
    );
  }
  return (
    <div className="flex items-center gap-3" data-testid="nav-user">
      {user.picture ? (
        <img src={user.picture} alt="" referrerPolicy="no-referrer" className="w-8 h-8 rounded-full border border-slate-200" />
      ) : null}
      <span className={`text-xs font-semibold ${textCls} max-w-[10rem] truncate`} data-testid="nav-user-name">
        {user.name || user.email}
      </span>
      <button type="button" data-testid="nav-signout" onClick={logout} aria-label="Sign out" className={`${textCls} ${hoverCls} transition-colors`}>
        <LogOut className="w-4 h-4" />
      </button>
    </div>
  );
};

export default NavAuth;
